import axios from 'axios';
import config from '@/webConfig'

export const getHeaderData = () => {
    const url = `${config.netWork}/stafi/v1/webapi/info/header`;
    return axios.get(url);
}

export const getStakevalueinfo = () => {
    const url = `${config.netWork}/stafi/v1/webapi/info/stakevalueinfo`;
    return axios.post(url)
}

export const getStakevaluelist = (cycle: number = 1, rsymbol?: string,limit?:number) => {
    const url = `${config.netWork}/stafi/v1/webapi/info/stakevaluelist`;
   
    return axios.post(url, {
        rsymbol,
        cycle,
        limit 
    })
}

export const getCapvaluelist=(cycle: number = 1, rsymbol?: string,limit:number=1095)=>{
    const url=`${config.netWork}/stafi/v1/webapi/info/capvaluelist`;
    return axios.post(url, {
        rsymbol,
        cycle,
        limit 
    })
}

export const getRatelist=()=>{
    const url=`${config.netWork}/stafi/v1/webapi/info/ratelist`;
    return axios.post(url)
}

export const getRtokenInfo = ()=>{
    const url = `${config.netWork}/stafi/v1/webapi/info/info`;
    return axios.post(url)
}

export const getRedeemvaluelist=(cycle: number = 1, rsymbol?: string ,limit?:number)=>{
    const url=`${config.netWork}/stafi/v1/webapi/info/redeemvaluelist`
    return axios.post(url, {
        rsymbol, 
        cycle,
        limit 
    })
}


export const getStaketxlist=(cycle: number = 1, rsymbol?: string,limit?:number)=>{
    const url=`${config.netWork}/stafi/v1/webapi/info/staketxlist`
    return axios.post(url, {
        rsymbol, 
        cycle,
        limit 
    })
}
 
export const getIncomelist=(cycle: number = 1, rsymbol?: string,limit:number=1095)=>{
    const url=`${config.netWork}/stafi/v1/webapi/info/incomelist`
    return axios.post(url, {
        rsymbol, 
        cycle,
        limit 
    })
}


export const getRsymbollist=()=>{
    const url=`${config.netWork}/stafi/v1/webapi/info/rsymbollist`;
    return axios.post(url)
}

export const getDailyincome=()=>{
    const url=`${config.netWork}/stafi/v1/webapi/info/dailyincome`;
    return axios.post(url)
}